"use client";
import { TObituaryFull, TObituaryImage } from "@/types/obituary";
import React from "react";
import type { RenderPhotoProps } from "react-photo-album";
import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
const breakpoints = [1080, 640, 384, 256, 128];

const GalleryComponent = ({ name, gallery }: TObituaryFull) => {
  const [index, setIndex] = React.useState(-1);
  let slides = generateSlides(gallery);
  return (
    <section className="w-full bg-secondary-200 px-2 py-12">
      <div className="container mx-auto flex flex-col gap-4">
        <h3 className="mx-auto text-center">Fotogalerie</h3>

        <PhotoAlbum
          layout="rows"
          photos={slides}
          targetRowHeight={160}
          onClick={({ index: current }) => setIndex(current)}
        />
      </div>
      <Lightbox
        index={index}
        slides={slides}
        open={index >= 0}
        close={() => setIndex(-1)}
      />
    </section>
  );
};

const generateSlides = (gallery: TObituaryImage[]) => {
  return gallery.map((photo) => {
    photo.url = photo.url.replace("http://", "https://");
    const width = photo.width;
    const height = photo.height;
    return {
      src: photo.url,
      width,
      height,
      srcSet: breakpoints.map((breakpoint) => {
        const breakpointHeight = Math.round((height / width) * breakpoint);
        return {
          src: photo.url.replace(
            "/upload",
            `/upload/h_${breakpointHeight}/g_auto/f_auto/q_auto/`
          ),
          width: breakpoint,
          height: breakpointHeight,
        };
      }),
    };
  });
};

export default GalleryComponent;
